import React, { useState } from 'react';
import ToggleButton from 'components/ToggleButton/ToggleButton';
import { useSelector } from 'react-redux';
import { defaultHidePermanentMeetingsSetting } from 'selectors/accountSelectors';
import intl from 'react-intl-universal';
import useSettingsChange from 'hooks/useSettingsChange';
import SettingToggleTooltip from './SettingToggleTooltip';
import { ACCOUNT_SETTING_HIDE_PERMANENT_MEETINGS } from 'constants/accountSettingsConstants';
import { selectAccountPermissions } from 'selectors/permissionsSelector';
import { ROLE_PERMISSION } from 'interfaces/Role';

export interface Props {
  setSettingsChangeError: Function;
}

const DefaultHidePermanentMeetingsButton = (props: Props) => {
  const { setSettingsChangeError } = props;
  const defaultHidePermanentMeetings = useSelector(defaultHidePermanentMeetingsSetting);
  const [ defaultHidePermanentMeetingsState, setDefaultHidePermanentMeetingsState ] = useState(defaultHidePermanentMeetings);
  const canEditSettings = useSelector(selectAccountPermissions)[ROLE_PERMISSION.MODIFY_OWN_ACCOUNT_GENERAL_SETTINGS];

  const changeSettings = useSettingsChange();

  return (
    <ToggleButton
      classNameLabel={''}
      id={ACCOUNT_SETTING_HIDE_PERMANENT_MEETINGS}
      label={<SettingToggleTooltip label={intl.get('hidePermanentMeetings')} tipLabel={intl.get('hidePermanentMeetingsTip')} />}
      leftLabel={false}
      hidenow={false}
      topLabel={false}
      disabled={!canEditSettings}
      field={{
        name: ACCOUNT_SETTING_HIDE_PERMANENT_MEETINGS,
        value: defaultHidePermanentMeetingsState,
        onChange: () => {
          if (!canEditSettings) { return; }
          return changeSettings(
            ACCOUNT_SETTING_HIDE_PERMANENT_MEETINGS,
            setDefaultHidePermanentMeetingsState,
            defaultHidePermanentMeetingsState,
            setSettingsChangeError
          );
        },
        onBlur: () => { return; }
      }}
    />
  );
};

export default DefaultHidePermanentMeetingsButton;
